export default __webpack_public_path__ + "static/media/first_class_mobile.6ee62eea.png";